import request from '@/utils/http.js';
import env from '../../env';
import { getPaasBaseUrl } from '../../../utils/baseUrl';
/**
 * 获取历史聊天消息
 * */
function getChatList(params = {}) {
  let url = `${getPaasBaseUrl()}/sdk/v2/message/latest-lists`;
  if (!params.isfirst) {
    url = '/v3/interacts/chat/get-list'
  }
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 删除聊天消息
 * */
function deleteMessage(params = {}) {
  const url = '/v3/interacts/chat/delete-message';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
/**
 * 批量删除聊天消息
 * */
function batchDeleteMessage(params = {}) {
  const url = '/v3/interacts/chat/batch-delete-message';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 删除活动所有聊天的消息
 * */
function deleteRoomMessage(params = {}) {
  const url = '/v3/interacts/chat/delete-room-message';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 删除用户所有聊天的消息
 * */
function deleteUserMessage(params = {}) {
  const url = '/v3/interacts/chat/delete-user-message';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取禁言用户列表
 * */
function getBannedList(params = {}) {
  const url = '/v3/interacts/chat-user/get-banned-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取踢出用户列表
 * */
function getKickedList(params = {}) {
  const url = '/v3/interacts/chat-user/get-kicked-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
/**
 * 获取全局踢出用户列表
 * */
function getGlobalKickedList(params = {}) {
  const url = '/v3/interacts/chat-user/get-global-kicked-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

function addKickedUser(params = {}) {
  const url = '/v3/interacts/chat-user/add-kicked-user';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
function delKickedUser(params = {}) {
  const url = '/v3/interacts/chat-user/batch-kicked';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
/**
 * 获取在线用户列表
 * */
function getOnlineList(params = {}) {
  const url =
    '/v3/interacts/chat-user/get-online-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取受限用户列表
 * */
function getBoundedList(params = {}) {
  const url = '/v3/interacts/chat-user/get-bounded-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 设置 / 取消用户禁言
 * */
function setBanned(params = {}) {
  const url = '/v3/interacts/chat-user/set-banned';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 设置 / 取消全体用户禁言
 * */
function setAllBanned(params = {}) {
  const url = '/v3/interacts/chat-user/set-all-banned';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 踢出用户 / 取消踢出
 * */
function setKicked(params = {}) {
  const url = '/v3/interacts/chat-user/set-kicked';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 发送自定义消息
 * */
function sendCustomMessage(params = {}) {
  const url = '/v3/interacts/chat/send-custom-message';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取私聊的聊天记录
 * */
function fetchPrivateChatList(params = {}) {
  const url = '/v3/interacts/chat-private/get-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取私聊的所有联系人列表
 * */
function fetchPrivateContactList(params = {}) {
  const url = '/v3/interacts/chat-private/get-rank-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

/**
 * 获取私聊聊天记录（PC观看）
 * */
function fetchPrivateChatHistoryList(params = {}) {
  const url = '/v3/interacts/chat-private/get-list';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

//聊天昵称加密配置
function setNicknameEncryption(params = {}) {
  const url = '/v3/interacts/chat-user/nickname-encryption';
  return request({
    url,
    method: 'POST',
    data: params
  });
}

function setBannedMode(params = {}) {
  const url = '/v3/interacts/chat-user/set-banned-mode';
  return request({
    url,
    method: 'POST',
    data: params
  });
}
function recommendMsg(params = {}) {
  const url = '/v3/interacts/chat/set-recommend';
  return request({
    url,
    method: 'POST',
    data: params
  });
}


export default {
  getChatList,
  getBannedList,
  getKickedList,
  getGlobalKickedList,
  addKickedUser,
  delKickedUser,
  getOnlineList,
  getBoundedList,
  setBanned,
  setAllBanned,
  setKicked,
  deleteMessage,
  batchDeleteMessage,
  deleteRoomMessage,
  deleteUserMessage,
  sendCustomMessage,
  fetchPrivateChatList,
  fetchPrivateContactList,
  fetchPrivateChatHistoryList,
  setNicknameEncryption,
  setBannedMode,
  recommendMsg
};
